import { SYSTEM_TYPE, TSystemType } from '@/constants/systemType'

// Staging => stage
// Production => 正式 / 封測

// 目前環境變數從 docker 餵 DEPLOY_ENV
// Staging => stage
// Production => 正式 / 封測
// 因為前端沒有 DEV 環境所以 DEV 變數自己另外給

export const CURRENT_SYSTEM_TYPE = process.env.SYSTEM_TYPE

export const ENVIORNMENT = {
  STAGE: 'Staging',
  PROD: 'Production',
  PRE: 'Pre',
  DEV: 'development',
}

export const configs = {
  [SYSTEM_TYPE.SHOP]: {
    [ENVIORNMENT.DEV]: {
      domainUrl: 'https://dev-www.tutorabcshop.com',
      apiUrl: 'https://dev-api.tutorabcshop.com/api',
      cookieDomain: '.tutorabcshop.com',
      logInUrl: 'https://stage-passport.tutorabcshop.com/api/url/login/1/tw',
      registerUrl: 'http://stage-passport.tutorabcshop.com/api/url/regist/1/tw',
      logOutUrl: 'http://stage-passport.tutorabcshop.com/api/logout/1',
      dittoApiUrl: 'https://dittostage.tutorabc.com/integrate',
      livemallclubLoginUrl: 'https://stage-passport.tutorabcshop.com/customs/login',
      livemallclubRegisterUrl: 'https://stage-passport.tutorabcshop.com/customs/register',
      adminUrl: '',
      GTM_ID: 'GTM-5GLXGB42',
      LINE_TAG_ID: '',
      SENTRY_DSN: 'https://0a10650d75e6c6e8b4bc1e2cf03c313f@sentry.tutorabc.com/2',
    },
    [ENVIORNMENT.STAGE]: {
      domainUrl: 'https://stage-www.tutorabcshop.com',
      apiUrl: 'https://stage-api.tutorabcshop.com/api',
      cookieDomain: '.tutorabcshop.com',
      logInUrl: 'https://stage-passport.tutorabcshop.com/api/url/login/1/tw',
      registerUrl: 'http://stage-passport.tutorabcshop.com/api/url/regist/1/tw',
      logOutUrl: 'http://stage-passport.tutorabcshop.com/api/logout/1',
      dittoApiUrl: 'https://dittostage.tutorabc.com/integrate',
      livemallclubLoginUrl: 'https://stage-passport.tutorabcshop.com/customs/login',
      livemallclubRegisterUrl: 'https://stage-passport.tutorabcshop.com/customs/register',
      adminUrl: '',
      GTM_ID: '',
      LINE_TAG_ID: '',
      SENTRY_DSN: 'https://0a10650d75e6c6e8b4bc1e2cf03c313f@sentry.tutorabc.com/2',
    },
    [ENVIORNMENT.PRE]: {
      domainUrl: 'https://wwwp.tutorabcshop.com',
      apiUrl: 'https://apip.tutorabcshop.com/api',
      cookieDomain: '.tutorabcshop.com',
      logInUrl: 'https://pre-passport.tutorabcshop.com/api/url/login/1/tw',
      registerUrl: 'https://pre-passport.tutorabcshop.com/api/url/regist/1/tw',
      logOutUrl: 'https://pre-passport.tutorabcshop.com/api/logout/1',
      dittoApiUrl: 'https://ditto-apip.tutorabc.com/integrate',
      livemallclubLoginUrl: 'https://stage-passport.tutorabcshop.com/customs/login',
      livemallclubRegisterUrl: 'https://stage-passport.tutorabcshop.com/customs/register',
      adminUrl: '',
      GTM_ID: 'GTM-5GLXGB42',
      LINE_TAG_ID: '',
      SENTRY_DSN: 'https://0a10650d75e6c6e8b4bc1e2cf03c313f@sentry.tutorabc.com/2',
    },
    [ENVIORNMENT.PROD]: {
      domainUrl: 'https://www.tutorabcshop.com',
      apiUrl: 'https://api.tutorabcshop.com/api',
      cookieDomain: '.tutorabcshop.com',
      logInUrl: 'https://passport.tutorabcshop.com/api/url/login/1/tw',
      registerUrl: 'https://passport.tutorabcshop.com/api/url/regist/1/tw',
      logOutUrl: 'https://passport.tutorabcshop.com/api/logout/1',
      dittoApiUrl: 'https://ditto-api.tutorabc.com/integrate',
      livemallclubLoginUrl: 'https://stage-passport.tutorabcshop.com/customs/login',
      livemallclubRegisterUrl: 'https://stage-passport.tutorabcshop.com/customs/register',
      adminUrl: '',
      GTM_ID: 'GTM-5JTQPM7',
      LINE_TAG_ID: '4b510851-a315-4659-9739-fdaeebb34685',
      SENTRY_DSN: 'https://0a10650d75e6c6e8b4bc1e2cf03c313f@sentry.tutorabc.com/2',
    },
  },
  [SYSTEM_TYPE.LIVE_MALL_CLUB]: {
    [ENVIORNMENT.DEV]: {
      domainUrl: 'https://dev-www.livemallclub.com',
      apiUrl: 'https://dev-api.livemallclub.com/api',
      cookieDomain: '.livemallclub.com',
      logInUrl: 'http://stage-passport.tutorabcshop.com/api/url/login/1/tw',
      registerUrl: 'http://stage-passport.tutorabcshop.com/api/url/regist/1/tw',
      logOutUrl: 'https://dev-www.livemallclub.com/',
      dittoApiUrl: 'https://dittostage.tutorabc.com/integrate',
      livemallclubLoginUrl: 'http://172.16.81.138:8045/customs/en-us/login',
      livemallclubRegisterUrl: 'http://172.16.81.138:8045/customs/en-us/register',
      adminUrl: 'https://dev-admin.livemallclub.com',
      GTM_ID: '',
      LINE_TAG_ID: '',
      SENTRY_DSN: 'https://5f56f9537ee1f61fc927d1d40b5e61b8@sentry.tutorabc.com/6',
    },
    [ENVIORNMENT.STAGE]: {
      domainUrl: 'https://stage-www.livemallclub.com',
      apiUrl: 'https://stage-api.livemallclub.com/api',
      cookieDomain: '.livemallclub.com',
      logInUrl: 'http://stage-passport.tutorabcshop.com/api/url/login/1/tw',
      registerUrl: 'http://stage-passport.tutorabcshop.com/api/url/regist/1/tw',
      logOutUrl: 'https://stage-www.livemallclub.com/',
      dittoApiUrl: 'https://dittostage.tutorabc.com/integrate',
      livemallclubLoginUrl: 'http://172.16.81.138:8045/customs/en-us/login',
      livemallclubRegisterUrl: 'http://172.16.81.138:8045/customs/en-us/register',
      adminUrl: 'https://stage-admin.livemallclub.com',
      GTM_ID: '',
      LINE_TAG_ID: '',
      SENTRY_DSN: 'https://5f56f9537ee1f61fc927d1d40b5e61b8@sentry.tutorabc.com/6',
    },
    [ENVIORNMENT.PRE]: {
      domainUrl: 'https://pre-www.livemallclub.com',
      apiUrl: 'https://pre-api.livemallclub.com/api',
      cookieDomain: '.livemallclub.com',
      logInUrl: 'https://pre-passport.tutorabcshop.com/api/url/login/1/tw',
      registerUrl: 'https://pre-passport.tutorabcshop.com/api/url/regist/1/tw',
      logOutUrl: 'https://pre-www.livemallclub.com',
      dittoApiUrl: 'https://ditto-apip.tutorabc.com/integrate',
      livemallclubLoginUrl: 'http://172.16.19.226:8045/customs/en-us/login',
      livemallclubRegisterUrl: 'http://172.16.19.226:8045/customs/en-us/register',
      adminUrl: 'https://pre-admin.livemallclub.com',
      GTM_ID: '',
      LINE_TAG_ID: '',
      SENTRY_DSN: 'https://5f56f9537ee1f61fc927d1d40b5e61b8@sentry.tutorabc.com/6',
    },
    [ENVIORNMENT.PROD]: {
      domainUrl: 'https://www.livemallclub.com',
      apiUrl: 'https://api.livemallclub.com/api',
      cookieDomain: '.livemallclub.com',
      logInUrl: 'http://stage-passport.tutorabcshop.com/api/url/login/1/tw',
      registerUrl: 'http://stage-passport.tutorabcshop.com/api/url/regist/1/tw',
      logOutUrl: 'https://www.livemallclub.com',
      dittoApiUrl: 'https://ditto-api.tutorabc.com/integrate',
      livemallclubLoginUrl: 'https://dev-passport.tutorabcshop.com/customs/login',
      livemallclubRegisterUrl: 'https://dev-passport.tutorabcshop.com/customs/register',
      adminUrl: 'https://admin.livemallclub.com',
      GTM_ID: '',
      LINE_TAG_ID: '',
      SENTRY_DSN: 'https://5f56f9537ee1f61fc927d1d40b5e61b8@sentry.tutorabc.com/6',
    },
  },
}
//AIzaSyA4TdgEHgRYVwdpHt42PaEteVjXLIPOtaA
export const googleCalendarConfig = {
  //57038433915-ahmfm8e90bh1ue1h6m968mtnpeehkrn8.apps.googleusercontent.com
  clientId: '57038433915-ahmfm8e90bh1ue1h6m968mtnpeehkrn8.apps.googleusercontent.com', // OAuth 2.0 用戶端 ID
  apiKey: 'AIzaSyA4TdgEHgRYVwdpHt42PaEteVjXLIPOtaA', // API金鑰 or API Key
  scope: 'https://www.googleapis.com/auth/calendar',
  discoveryDocs: ['https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest'],
}

declare const process: {
  browser: boolean
  env: {
    DEPLOY_ENV: string
    SYSTEM_TYPE: TSystemType
  }
}

export const envConfigs = configs[CURRENT_SYSTEM_TYPE][process.env.DEPLOY_ENV]
